import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import axios from "axios";

//redux imports
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";

//middleware for async acitons
import thunk from "redux-thunk";

//redux state persistor
import { persistStore, persistReducer } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import storage from "redux-persist/lib/storage";
//reducers
import authReducer from "./redux/reducers/auth/auth.reducer";
import dashboardReducer from "./redux/reducers/dashboard/dashboard.reducer";
import transactionReducer from "./redux/reducers/transactions/transaction.reducer";
import customersReducer from "./redux/reducers/customers/customers.reducer";
import fileExportReducer from "./redux/reducers/fileexport/fileexport.reducer";
import redemptionsReducer from "./redux/reducers/redemptions/redemptions.reducer";
import productsReducer from "./redux/reducers/products/products.reducer";
import raffleReducer from "./redux/reducers/raffle/raffle.reducer";
import adsReducer from "./redux/reducers/ads/ads.reducer";

//redux devtools composer
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//persist config for auth
const persistConfig = {
  key: "cms-authetication-glyph",
  storage,
  whitelist: ["cmsAuth"],
};

//root reducer combining multiple reducers
const rootReducer = combineReducers({
  cmsAuthenticator: persistReducer(persistConfig, authReducer),
  cmsData: dashboardReducer,
  cmsTransactions: transactionReducer,
  cmsCustomers: customersReducer,
  cmsFileExport: fileExportReducer,
  cmsRedemptions: redemptionsReducer,
  cmsProducts: productsReducer,
  cmsRaffle: raffleReducer,
  cmsAdClicks: adsReducer,
});

//redux store
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

//persistor persisting redux store
export const persistor = persistStore(store);
// persistor.purge();

//authorization header
axios.defaults.headers.common["Authorization"] = "6k^o8o_a8ne1n&8@&_@r1pg!i@jn8^1pvav$";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
